import { useEffect } from 'react';
import ReactPixel from 'react-facebook-pixel';

const Pixels = ({ pixelList }) => {
  // ReactPixel.init('yourPixelIdGoesHere');

  useEffect(() => {
    // console.log(pixelList);
  }, []);

  return <div></div>;
};

export default Pixels;
